import React, { useEffect, useState } from 'react';
import {
  FuelBottomSheet,
  FuelFlex,
  FuelOriginAndDestination,
} from '@frete.com/fuel-station-react';
import WhatsAppButton from '@components/ui/WhatsAppButton';
import useGlobals from '@hooks/useGlobals';
import {
  FuelGridContainer,
  FuelGridItem,
  FuelInteractiveIcon,
} from '@frete.com/fuel-react';
import { getTextToContactTruckerWhatsApp } from '@helpers/journeys/whatsappTalk';
import LocationPulse from '@components/ui/Location/LocationPulse';
import { hasOpacity } from '@helpers/journeys/status';
import TruckerStatus from '../../../Trucker/TruckerStatus';
import * as Styled from './JourneysAllTabMobileStyles';
import { JourneyListItemPropsInterface } from '../../JourneyListType';
import KebabList from '../../KebabList';
import ActionsButtons from '../ActionsButtons';

function JourneysAllTabMobile(props: JourneyListItemPropsInterface) {
  const [open, setOpen] = useState(false);
  const {
    trucker: { name, avatar, phone, lastLocation },
    address,
    handleClick,
    handlerModalDialogue,
    onCallbackSentWhatsApp,
    isMobile,
    id,
    status,
  } = props;
  const { user } = useGlobals();
  const fullName = name.split(' ');
  const firstName = fullName ? fullName[0] : '';
  const messageWhatsApp = getTextToContactTruckerWhatsApp({
    truckerName: firstName,
    companyName: user?.data?.company?.name || '',
    userName: user?.data?.name.split(' ')[0] || '',
    type: 'journey',
    id,
  });
  const hasLocation = lastLocation.city.name && lastLocation.state.acronym;

  useEffect(() => {
    if (!isMobile && open) {
      setOpen(false);
    }
  }, [isMobile]);

  return (
    <>
      <Styled.WrapperStyledFuelGridContainer
        role="button"
        onClick={(event) => handleClick(event, props)}
        data-testid="JourneysAllListItemMobile"
      >
        <FuelGridContainer gapRow={32}>
          <FuelGridItem sm={3}>
            <TruckerStatus
              avatar={avatar}
              name={name}
              status={
                status.slug === 'canceled'
                  ? `${status.slug}:${status.by}`
                  : status.slug
              }
              hasOpacity={hasOpacity(status)}
            />
          </FuelGridItem>
          <FuelGridItem sm={1}>
            <FuelFlex
              defaultProps={{
                alignItems: 'center',
                gap: 'km4',
                justifyContent: 'flex-end',
              }}
            >
              {phone && (
                <div>
                  <WhatsAppButton
                    phone={phone}
                    message={messageWhatsApp}
                    onCallbackSentWhatsApp={() =>
                      onCallbackSentWhatsApp?.(props)
                    }
                  />
                </div>
              )}
              <FuelInteractiveIcon
                icon="kebab-vertical"
                iconStyle="filled"
                size="medium"
                onClick={() => setOpen(!open)}
                data-testid={`label-button-${id}`}
              />
            </FuelFlex>
          </FuelGridItem>
          {hasLocation && (
            <FuelGridItem sm={4}>
              <LocationPulse
                text={`Em ${lastLocation.city.name}, ${lastLocation.state.acronym}`}
              />
            </FuelGridItem>
          )}
          <FuelGridItem sm={4}>
            <FuelOriginAndDestination
              origin={address.pickup}
              destination={address.delivery}
              isLarge={false}
            />
          </FuelGridItem>
          <FuelGridItem sm={4}>
            <ActionsButtons {...props} />
          </FuelGridItem>
        </FuelGridContainer>
      </Styled.WrapperStyledFuelGridContainer>
      <FuelBottomSheet
        isOpen={open}
        title="Ações da viagem"
        portalName="portal-journey-menu-kebab-vertical"
        height={360}
        onClose={() => setOpen(false)}
      >
        <KebabList
          openModalConfirm={() => handlerModalDialogue?.(props)}
          closeBottonSheet={() => setOpen(false)}
          {...props}
        />
      </FuelBottomSheet>
    </>
  );
}

export default JourneysAllTabMobile;
